import React from 'react';
import dayjs from 'dayjs';
import { DatePicker, Input } from 'antd';

const ActivePeriodFields = ({ formData, updateField }) => {
  const startValue = formData?.activeStartDate ? dayjs(formData.activeStartDate) : null;
  const endValue = formData?.activeEndDate ? dayjs(formData.activeEndDate) : null;

  return (
    <>
      <div className='step-group'>
        <div className='step-section-title Title-dark'>Active Period</div>
        <div className='step-subtitle mb-8'>
          BAU rules run between fixed dates. Leave the end date blank for no end date.
        </div>

        <div className='step-group d-flex d-flex-row gap-16'>
            <div className='step-group-inner DatePicker-inner step-group'>
                <div className='step-form-label'>
                    Start Date and Time
                </div>
                <DatePicker
                value={startValue}
                showTime
                onChange={(value) => updateField('activeStartDate', value ? value.format('YYYY-MM-DD HH:mm') : '')}
                className='Input-border InputText DatePicker-input'
                />
            </div>

            <div className='step-group-inner DatePicker-inner step-group'>
                <div className='step-form-label'>
                    End Date and Time
                </div>
                <DatePicker
                value={endValue}
                showTime
                onChange={(value) => updateField('activeEndDate', value ? value.format('YYYY-MM-DD HH:mm') : '')}
                className='Input-border InputText DatePicker-input'
                />
            </div>
        </div>
      </div>
    </>
  );
};

export default ActivePeriodFields;
